import { useSelector } from 'react-redux';

export default function useAuth(selector = el => el) {
  return useSelector(({ auth }) => selector(auth));
}
